module.exports = __webpack_public_path__ + "img/upload-file.d03d58b0.svg";